import Label from "Components/Common/components/Label";
import Update from "Components/GMS/Pdw/upload/Update";
import React from "react";
import { Modal } from "react-bootstrap";

const UpdatePDW = (props) => {
  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={props.showUpdatePopup}
      onHide={props.modalUpdateClose}
    >
      <Modal.Header closeButton>
        <div>
          <Label
            message={
              props?.type === "CBM" ? "Upload XLS" : "Upload XLS - Update"
            }
            fontSize={0.875}
            fontWeight="600"
          />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="row ">
          <div className="m-2">
            <div className="row">
              <Update
                modalUpdateClose={props.modalUpdateClose}
                load_Products_By_Category={props.fetchData}
                fromProduct={true}
                ruleId={props.ruleId}
                type={props.type}
                display={props.display}
                compatibilityLevel={props.compatibilityLevel}
                fetchData={props.fetchData}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UpdatePDW;
